import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';

import Immutable from 'seamless-immutable';
import moment from 'moment';
import { ProjectType, ConsultationFormType, ProjectMode } from '../../../utils/enums';
import find from 'lodash.find';
import ContactListItem from './ContactListItem';

export class ContactTypeConsultationForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			opened: props.isOnlyOneConsultationForms
		};
	}

	toggleOpen = (e) => {
		e.preventDefault();
		this.setState({
			opened: !this.state.opened
		});
	};

	render() {
		const {
			items,
			title,
			officeId,
			thematicAreaId,
			districtId,
			projectId,
			onCancel,
			agreementAccepted,
			agreementHistory,
			agreementAcceptedRequired,
			scrollToAgreement,
			isAuth = false,
			mode = ProjectMode.NotSetted
		} = this.props;
		const { opened } = this.state;

		const emailAddress = find(items, { type: ConsultationFormType.EmailAddress });

		return (
			<Fragment>
				{emailAddress && (
					<Fragment>
						<div className="consultation__title margin-top-30 margin-bottom-15">Formularz kontaktowy</div>
						<div className="consultations__item">
							<div className="consultations__body">
								<ContactListItem
									disabled={!isAuth && [ProjectMode.Citizen, ProjectMode.Close].includes(mode)}
									title={title}
									officeId={officeId}
									thematicAreaId={thematicAreaId}
									districtId={districtId}
									projectId={projectId}
									onCancel={onCancel}
									agreementAccepted={agreementAccepted}
									agreementHistory={agreementHistory}
									agreementAcceptedRequired={agreementAcceptedRequired}
									scrollToAgreement={scrollToAgreement}
								/>
							</div>
						</div>
					</Fragment>
				)}
			</Fragment>
		);
	}
}
ContactTypeConsultationForm.defaultProps = {
	categoryPointDivision: false,
	disabled: false,
	id: 0,
	index: 0,
	isResultPublished: false,
	loggedUserId: 0,
	maxPoint: 0,
	outOfRangeVoteDates: false,
	outOfRangeDistricts: false,
	prefixName: '',
	projectType: 0,
	publishType: -1,
	rowId: 0,
	shortDescription: '',
	status: -1,
	statusName: '',
	type: 0,
	voted: false,
	voteFrom: moment().format('YYYY-MM-DD'),
	voteTo: moment().format('YYYY-MM-DD'),
	agreementAccepted: false,
	agreementAcceptedRequired: false,

	answers: [],
	attachments: [],
	categories: [],
	isExecuting: false
};
